export default {
  props: {
    nav: {
      default: true,
    },
    stepType: null,
  },
  data() {
    return {
      isAdmin: window.isAdmin,
      isFromAuthUser: window.isFromAuthUser,
    }
  },
}



// WEBPACK FOOTER //
// ./resources/js/components/trials/step-mixin.js